import React from 'react';

// Styles & Assets
import styles from './PollScoreChart.module.css';

// Serivces
import { cssvar } from '../../../services/charts';

// Hooks
import { useTranslation } from 'react-i18next';

// Interfaces
import { Case } from '../../../interfaces/Patient';


// Other
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';

import {
    LineChart,
    // BarChart,
    // PieChart,
    // ScatterChart,
    // RadarChart,
    // MapChart,
    // TreeChart,
    // TreemapChart,
    // GraphChart,
    // GaugeChart,
    // FunnelChart,
    // ParallelChart,
    // SankeyChart,
    // BoxplotChart,
    // CandlestickChart,
    // EffectScatterChart,
    // LinesChart,
    // HeatmapChart,
    // PictorialBarChart,
    // ThemeRiverChart,
    // SunburstChart,
    // CustomChart,
} from 'echarts/charts';
// import components, all suffixed with Component
import {
    // GridSimpleComponent,
    GridComponent,
    // PolarComponent,
    // RadarComponent,
    // GeoComponent,
    // ParallelComponent,
    // CalendarComponent,
    // GraphicComponent,
    // ToolboxComponent,
    // SingleAxisComponent,
    TooltipComponent,
    // AxisPointerComponent,
    // BrushComponent,
    // TitleComponent,
    // TimelineComponent,
    // MarkPointComponent,
    // MarkLineComponent,
    MarkAreaComponent,
    // LegendComponent,
    // LegendScrollComponent,
    // LegendPlainComponent,
    // DataZoomComponent,
    // DataZoomSliderComponent,
    // DataZoomInsideComponent,
    // VisualMapComponent,
    // VisualMapContinuousComponent,
    // VisualMapPiecewiseComponent,
    // AriaComponent,
    // TransformComponent,
    // DatasetComponent,
} from 'echarts/components';
import {
    CanvasRenderer,
    // SVGRenderer,
} from 'echarts/renderers';


import moment from 'moment';

// Interfaces
interface Element { value: number, date: string }

const PollScoreChart: React.FC<{
    caso: Case,
    elements: Element[]
}> = ({ caso, elements }) => {

    const { t } = useTranslation();

    let startDate: moment.Moment | string | null = null;
    let endHad: string | undefined | null = null;
    let endSevenDays: moment.Moment | string | undefined | null = null;
    let endThirtyDays: moment.Moment | string | undefined | null = null;

    let had = 0;
    let seven = 0;
    let thirty = 0;

    let had_percentage = 0;
    let seven_percentage = 0;
    let thirty_percentage = 0;

    const calculateIniPercentage = (before_percent: number, actual_percent: number) => {
        return (5 + ((before_percent !== 0 && actual_percent !== 0) ? before_percent : 0)) + '%';
    };

    const calculateEndPercentage = (before_percent: number, actual_percent: number) => {
        return 5 + ((before_percent !== 0 && actual_percent !== 0) ?
            before_percent + actual_percent :
            (before_percent === 0 && actual_percent !== 0) ?
                actual_percent : 0) + '%';
    };

    const getDatesHospitalization = () => {
        const diffDate = Number(caso.out_days ?? -1);
        startDate = caso.start_date;
        if (diffDate === -1) {
            endHad = null;
            endSevenDays = null;
            endThirtyDays = null;
        }
        else if (diffDate <= 7) {
            endHad = caso.end_date;
            if (endHad !== null && endHad !== undefined) endSevenDays = addDays(endHad, 7);
            endThirtyDays = null;
        }
        else if (diffDate > 7) {
            endHad = caso.end_date;
            if (endHad !== null && endHad !== undefined) endSevenDays = addDays(endHad, 7);
            if (endHad !== null && endHad !== undefined) endThirtyDays = addDays(endHad, diffDate);
        }

    };

    const addDays = (date: string, days: number) => {
        const d = new Date(date);
        return moment(moment(d).add(days, 'days'), 'YYYY-MM-DD[T]HH:mm:ssZ').format();
    };

    const betweenDate = (d: string, start: Date | moment.Moment | string | null, end: Date | moment.Moment | string | null | undefined) => {
        if (start === null || end === undefined || end === null) return false;
        const date = moment(d, 'DD-MM-YYYY[\n]HH:mm').format('YYYY-MM-DD[T]HH:mm:ss');
        return (date >= start && date <= end) ? true : false;
    };

    const calculatePercentage = (number1: number, total: number) => {
        return (number1 !== 0) ? (number1 * 100) / total : 0;
    };

    const calcularDataXAxis = (dates: Element[]) => {
        const dataValues: string[] | undefined = [];
        let betweenHad = false;
        let betweenSeven = false;
        let betweenThirty = false;
        had = 0;
        seven = 0;
        thirty = 0;
        had_percentage = 0;
        seven_percentage = 0;
        thirty_percentage = 0;

        getDatesHospitalization();
        for (let i = 0; i < dates.length; i++) {
            if (endHad != null) {
                betweenHad = betweenDate(dates[i].date, startDate, endHad);
                betweenSeven = betweenDate(dates[i].date, endHad, endSevenDays);
                if (endThirtyDays != null && endSevenDays !== undefined) {
                    betweenThirty = betweenDate(dates[i].date, endSevenDays, endThirtyDays);
                    if (endThirtyDays > dates[i].date) betweenThirty = true;
                } else betweenThirty = false;
            }
            else {
                betweenHad = true;
                betweenSeven = false;
                betweenThirty = false;
            }

            if (betweenHad) had++;
            else if (betweenSeven) seven++;
            else if (betweenThirty) thirty++;

            betweenHad = false;
            betweenSeven = false;
            betweenThirty = false;

            dataValues.push(dates[i].date);
        }

        had_percentage = calculatePercentage(had, dates.length);
        seven_percentage = calculatePercentage(seven, dates.length);
        thirty_percentage = calculatePercentage(thirty, dates.length);

        return dataValues;
    };

    const MARGIN_GRID = 5;

    const createMarkArea = (
        show: boolean,
        label: string,
        x1: string,
        x2: string,
        color: string
    ) => {
        if (!window.config.CHARTS_WITH_SECTIONS) return undefined;
        return {
            type: 'line',
            markArea: {
                silent: true,
                data: [
                    [{
                        label: {
                            show: show,
                            position: 'insideTopLeft',
                            distance: 20,
                            color: cssvar('--secondary-color'),
                            fontFamily: 'MontserratRegular',
                            fontWeight: 700
                        },
                        name: label,
                        x: x1,
                        y: 'max'
                    }, {
                        x: x2,
                        y: 'max'
                    },
                    ],
                ],
                itemStyle: { color }
            }
        }
    }

    const chartOption = {
        xAxis: { type: undefined, data: calcularDataXAxis(elements) },
        yAxis: { type: 'value', show: true },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                shadowStyle: { color: 'rgba(0, 0, 0, 0.03)' }
            }
        },
        series: [
            {
                data: elements ?? [],
                type: 'line',
                symbol: 'circle',
                symbolSize: 9,
                label: { show: false },
                color: 'rgba(0,0,0)',
            },
            createMarkArea(
                had > 0,
                t('HAD'),
                calculateIniPercentage(0, had_percentage),
                calculateEndPercentage(0, had_percentage),
                cssvar('--discharge-status-had')),
            createMarkArea(
                seven > 0,
                t('minus_equal_7_days_discharge'),
                calculateIniPercentage(had_percentage, seven_percentage),
                calculateEndPercentage(had_percentage, seven_percentage),
                cssvar('--discharge-status-seven-days')
            ),
            createMarkArea(
                thirty > 0,
                t('less_30_days_discharge'),
                calculateIniPercentage(had_percentage + seven_percentage, thirty_percentage),
                calculateEndPercentage(had_percentage + seven_percentage, thirty_percentage),
                cssvar('--discharge-status-thirty-days')
            ),
        ],
        textStyle: { fontFamily: 'MontserratRegular' },
        grid: { left: MARGIN_GRID + '%', top: '2%', right: '0%', bottom: MARGIN_GRID + '%' }
    };

    echarts.use([LineChart, GridComponent, TooltipComponent,
        MarkAreaComponent, CanvasRenderer,
    ]);

    return (
        <div className={styles.CVChartContainer}>
            <ReactEChartsCore
                echarts={echarts}
                style={{ height: '100%', width: '100%' }}
                notMerge={true}
                lazyUpdate={true}
                option={chartOption}
            />
        </div>
    );
};

export default PollScoreChart;